export enum ECommonUnit {
  yenPerSqm = 'yenPerSqm',
  yenPerItem = 'yenPerItem'
}
